import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Star, ExternalLink } from "lucide-react";
import { BUSINESS } from "@/data/businessInfo";
import { SERVICES } from "@/data/services";
import { LOCATIONS } from "@/data/locations";

export const Footer = () => {
  return (
    <footer className="bg-[#401303] text-white noise-overlay" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img src={BUSINESS.logo} alt={BUSINESS.name} className="h-20 w-auto mb-4" />
            <p className="text-white/70 text-sm leading-relaxed mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {BUSINESS.description}
            </p>
            <div className="flex items-center gap-2 mb-2">
              {[1,2,3,4,5].map(i => <Star key={i} className="w-4 h-4 fill-[#D97904] text-[#D97904]" />)}
              <span className="text-sm text-[#BF8D30] font-semibold ml-1">5.0</span>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <a href={BUSINESS.social.facebook} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-[#BF8D30]/20 transition-colors duration-200" data-testid="footer-facebook"><Facebook className="w-4 h-4" /></a>
              <a href={BUSINESS.social.yelp} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-[#BF8D30]/20 transition-colors duration-200" data-testid="footer-yelp"><ExternalLink className="w-4 h-4" /></a>
              <a href={BUSINESS.social.bbb} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-[#BF8D30]/20 transition-colors duration-200" data-testid="footer-bbb"><ExternalLink className="w-4 h-4" /></a>
            </div>
          </div>

          {/* Services */}
          <nav aria-label="Services">
            <h3 className="text-[#BF8D30] text-sm font-bold uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Services</h3>
            <ul className="space-y-2">
              {SERVICES.map(s => (
                <li key={s.id}><Link to={`/services/${s.residential.slug}`} className="text-sm text-white/70 hover:text-[#BF8D30] transition-colors duration-200">{s.title}</Link></li>
              ))}
            </ul>
          </nav>

          {/* Service Areas */}
          <nav aria-label="Service Areas">
            <h3 className="text-[#BF8D30] text-sm font-bold uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Service Areas</h3>
            <ul className="space-y-2">
              {LOCATIONS.slice(0, 8).map(l => (
                <li key={l.id}><Link to={`/service-areas/${l.id}`} className="text-sm text-white/70 hover:text-[#BF8D30] transition-colors duration-200">{l.name}</Link></li>
              ))}
              <li><Link to="/service-areas" className="text-sm text-[#BF8D30] hover:text-[#D97904] font-semibold transition-colors duration-200">View All Areas</Link></li>
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h3 className="text-[#BF8D30] text-sm font-bold uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#BF8D30] mt-0.5 flex-shrink-0" />
                <a href={`tel:${BUSINESS.phoneRaw}`} className="text-sm text-white/70 hover:text-[#BF8D30] transition-colors duration-200">{BUSINESS.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#BF8D30] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${BUSINESS.email}`} className="text-sm text-white/70 hover:text-[#BF8D30] transition-colors duration-200">{BUSINESS.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#BF8D30] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-white/70">Serving the Treasure Coast & Palm Beach County</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[#BF8D30] mt-0.5 flex-shrink-0" />
                <div className="text-sm text-white/70">
                  <p>Open 24 Hours</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">&copy; {new Date().getFullYear()} {BUSINESS.name}. All rights reserved. License #{BUSINESS.license}</p>
          <div className="flex items-center gap-4">
            <Link to="/contact" className="text-xs text-white/50 hover:text-[#BF8D30] transition-colors duration-200">Privacy Policy</Link>
            <Link to="/contact" className="text-xs text-white/50 hover:text-[#BF8D30] transition-colors duration-200">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
